import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    phoneIcon = "phoneIcon",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.phoneIcon]: string;
    };
}

export interface FooterPhoneStyles {
    titleWrapper?: InjectableCss;
}

export const newsStyle: FooterPhoneStyles = {
    titleWrapper: {
        css: css`
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: #f6f4f6;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        justify-content: flex-start;
                        align-items: baseline;
                    `,
                    css`
                        display: flex;
                        justify-content: center;
                        align-items: baseline;
                    `,
                    css`
                        display: flex;
                        justify-content: center;
                        align-items: baseline;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = newsStyle;

export const SEFooterPhone: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper>
            <Typography as="span" {...styles.titleWrapper}>
                <Img src={fields.phoneIcon} /> {parse(fields.title, parserOptions)}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SEFooterPhone,
    definition: {
        group: "Basic",
        displayName: "SE FooterPhone",
        fieldDefinitions: [
            {
                name: fields.phoneIcon,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                name: fields.title,
                fieldType: "General",
                editorTemplate: "RichTextField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
